"use strict";

module.exports = {
  0: 'HOPOPT (0) IPv6 Hop-by-Hop Option',
  1: 'ICMP (1) Internet Control Message',
  2: 'IGMP (2) Internet Group Management',
  3: 'GGP (3) Gateway-to-Gateway',
  4: 'IPv4 (4) IPv4 encapsulation',
  5: 'ST (5) Stream',
  6: 'TCP (6) Transmission Control',
  7: 'CBT (7) CBT',
  8: 'EGP (8) Exterior Gateway Protocol',
  9: 'IGP (9) any private interior gateway (used by Cisco for their IGRP)',
  10: 'BBN-RCC-MON (10) BBN RCC Monitoring',
  11: 'NVP-II (11) Network Voice Protocol',
  12: 'PUP (12) PUP',
  13: 'ARGUS (deprecated) (13) ARGUS',
  14: 'EMCON (14) EMCON',
  15: 'XNET (15) Cross Net Debugger',
  16: 'CHAOS (16) Chaos',
  17: 'UDP (17) User Datagram',
  18: 'MUX (18) Multiplexing',
  19: 'DCN-MEAS (19) DCN Measurement Subsystems',
  20: 'HMP (20) Host Monitoring',
  21: 'PRM (21) Packet Radio Measurement',
  22: 'XNS-IDP (22) XEROX NS IDP',
  23: 'TRUNK-1 (23) Trunk-1',
  24: 'TRUNK-2 (24) Trunk-2',
  25: 'LEAF-1 (25) Leaf-1',
  26: 'LEAF-2 (26) Leaf-2',
  27: 'RDP (27) Reliable Data Protocol',
  28: 'IRTP (28) Internet Reliable Transaction',
  29: 'ISO-TP4 (29) ISO Transport Protocol Class 4',
  30: 'NETBLT (30) Bulk Data Transfer Protocol',
  31: 'MFE-NSP (31) MFE Network Services Protocol',
  32: 'MERIT-INP (32) MERIT Internodal Protocol',
  33: 'DCCP (33) Datagram Congestion Control Protocol',
  34: '3PC (34) Third Party Connect Protocol',
  35: 'IDPR (35) Inter-Domain Policy Routing Protocol',
  36: 'XTP (36) XTP',
  37: 'DDP (37) Datagram Delivery Protocol',
  38: 'IDPR-CMTP (38) IDPR Control Message Transport Proto',
  39: 'TP++ (39) TP++ Transport Protocol',
  40: 'IL (40) IL Transport Protocol',
  41: 'IPv6 (41) IPv6 encapsulation',
  42: 'SDRP (42) Source Demand Routing Protocol',
  43: 'IPv6-Route (43) Routing Header for IPv6',
  44: 'IPv6-Frag (44) Fragment Header for IPv6',
  45: 'IDRP (45) Inter-Domain Routing Protocol',
  46: 'RSVP (46) Reservation Protocol',
  47: 'GRE (47) Generic Routing Encapsulation',
  48: 'DSR (48) Dynamic Source Routing Protocol',
  49: 'BNA (49) BNA',
  50: 'ESP (50) Encap Security Payload',
  51: 'AH (51) Authentication Header',
  52: 'I-NLSP (52) Integrated Net Layer Security  TUBA',
  53: 'SWIPE (deprecated) (53) IP with Encryption',
  54: 'NARP (54) NBMA Address Resolution Protocol',
  55: 'MOBILE (55) IP Mobility',
  56: 'TLSP (56) Transport Layer Security Protocol         using Kryptonet key management',
  57: 'SKIP (57) SKIP',
  58: 'IPv6-ICMP (58) ICMP for IPv6',
  59: 'IPv6-NoNxt (59) No Next Header for IPv6',
  60: 'IPv6-Opts (60) Destination Options for IPv6',
  61: ' (61) any host internal protocol',
  62: 'CFTP (62) CFTP',
  63: ' (63) any local network',
  64: 'SAT-EXPAK (64) SATNET and Backroom EXPAK',
  65: 'KRYPTOLAN (65) Kryptolan',
  66: 'RVD (66) MIT Remote Virtual Disk Protocol',
  67: 'IPPC (67) Internet Pluribus Packet Core',
  68: ' (68) any distributed file system',
  69: 'SAT-MON (69) SATNET Monitoring',
  70: 'VISA (70) VISA Protocol',
  71: 'IPCV (71) Internet Packet Core Utility',
  72: 'CPNX (72) Computer Protocol Network Executive',
  73: 'CPHB (73) Computer Protocol Heart Beat',
  74: 'WSN (74) Wang Span Network',
  75: 'PVP (75) Packet Video Protocol',
  76: 'BR-SAT-MON (76) Backroom SATNET Monitoring',
  77: 'SUN-ND (77) SUN ND PROTOCOL-Temporary',
  78: 'WB-MON (78) WIDEBAND Monitoring',
  79: 'WB-EXPAK (79) WIDEBAND EXPAK',
  80: 'ISO-IP (80) ISO Internet Protocol',
  81: 'VMTP (81) VMTP',
  82: 'SECURE-VMTP (82) SECURE-VMTP',
  83: 'VINES (83) VINES',
  84: 'IPTM (84) Internet Protocol Traffic Manager',
  85: 'NSFNET-IGP (85) NSFNET-IGP',
  86: 'DGP (86) Dissimilar Gateway Protocol',
  87: 'TCF (87) TCF',
  88: 'EIGRP (88) EIGRP',
  89: 'OSPFIGP (89) OSPFIGP',
  90: 'Sprite-RPC (90) Sprite RPC Protocol',
  91: 'LARP (91) Locus Address Resolution Protocol',
  92: 'MTP (92) Multicast Transport Protocol',
  93: 'AX.25 (93) AX.25 Frames',
  94: 'IPIP (94) IP-within-IP Encapsulation Protocol',
  95: 'MICP (deprecated) (95) Mobile Internetworking Control Pro.',
  96: 'SCC-SP (96) Semaphore Communications Sec. Pro.',
  97: 'ETHERIP (97) Ethernet-within-IP Encapsulation',
  98: 'ENCAP (98) Encapsulation Header',
  99: ' (99) any private encryption scheme',
  100: 'GMTP (100) GMTP',
  101: 'IFMP (101) Ipsilon Flow Management Protocol',
  102: 'PNNI (102) PNNI over IP',
  103: 'PIM (103) Protocol Independent Multicast',
  104: 'ARIS (104) ARIS',
  105: 'SCPS (105) SCPS',
  106: 'QNX (106) QNX',
  107: 'A/N (107) Active Networks',
  108: 'IPComp (108) IP Payload Compression Protocol',
  109: 'SNP (109) Sitara Networks Protocol',
  110: 'Compaq-Peer (110) Compaq Peer Protocol',
  111: 'IPX-in-IP (111) IPX in IP',
  112: 'VRRP (112) Virtual Router Redundancy Protocol',
  113: 'PGM (113) PGM Reliable Transport Protocol',
  114: ' (114) any 0-hop protocol',
  115: 'L2TP (115) Layer Two Tunneling Protocol',
  116: 'DDX (116) D-II Data Exchange (DDX)',
  117: 'IATP (117) Interactive Agent Transfer Protocol',
  118: 'STP (118) Schedule Transfer Protocol',
  119: 'SRP (119) SpectraLink Radio Protocol',
  120: 'UTI (120) UTI',
  121: 'SMP (121) Simple Message Protocol',
  122: 'SM (deprecated) (122) Simple Multicast Protocol',
  123: 'PTP (123) Performance Transparency Protocol',
  124: 'ISIS over IPv4 (124) ',
  125: 'FIRE (125) ',
  126: 'CRTP (126) Combat Radio Transport Protocol',
  127: 'CRUDP (127) Combat Radio User Datagram',
  128: 'SSCOPMCE (128) ',
  129: 'IPLT (129) ',
  130: 'SPS (130) Secure Packet Shield',
  131: 'PIPE (131) Private IP Encapsulation within IP',
  132: 'SCTP (132) Stream Control Transmission Protocol',
  133: 'FC (133) Fibre Channel',
  134: 'RSVP-E2E-IGNORE (134) ',
  135: 'Mobility Header (135) ',
  136: 'UDPLite (136) ',
  137: 'MPLS-in-IP (137) ',
  138: 'manet (138) MANET Protocols',
  139: 'HIP (139) Host Identity Protocol',
  140: 'Shim6 (140) Shim6 Protocol',
  141: 'WESP (141) Wrapped Encapsulating Security Payload',
  142: 'ROHC (142) Robust Header Compression',
  253: ' (253) Use for experimentation and testing',
  254: ' (254) Use for experimentation and testing',
  255: 'Reserved (255) '
};